import { render } from "./heat.vue?vue&type=template&id=2fecd9de"
import script from "./heat.vue?vue&type=script&lang=js"
export * from "./heat.vue?vue&type=script&lang=js"

import "./heat.vue?vue&type=style&index=0&id=2fecd9de&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__